module.exports = __webpack_public_path__ + "static/media/mk.c62e5818.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/mk.svg
// module id = 884
// module chunks = 0